import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a53a02c2cc25000147c8e7b_1787077113223_72f7bd87/smarck_m/src/app/about/components/AboutPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/6a53a02c2cc25000147c8e7b_1787077113223_72f7bd87/smarck_m/src/components/AppLayout.tsx");
